<section id="card-container">
	<div (click)="expandRow($event)" class="card-doubts" [id]="'card-' + id">
		<span>{{ title }}</span>
		<img alt="top-arrow" [src]="opened ? 'assets/icons/svg/arrow-top-white.svg' : 'assets/icons/svg/top-arrow.svg'" loading="lazy" />
	</div>

	<div class="resposta-pergunta hidden">
		@if (answer) {
			{{ answer }}
		} @else {
			<ng-content></ng-content>
		}
	</div>
</section>
